import {useContext} from "react";
import {StoreContext} from "../store/store";

/**
 * store/hooks/index.js
 *
 * Returns an array containing the current state object, and store action dispatch method
 * Usage: const [state, dispatch] = useStore();
 */

const useStore = () => useContext(StoreContext);

export default useStore;